export default {
  SEARCH_CATALOG_KUSPIT_ORIGIN_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_ORIGIN_QUERY'),
  CATALOG_KUSPIT_ORIGIN_REPOSITORY: Symbol.for('CATALOG_KUSPIT_ORIGIN_REPOSITORY'),
  CATALOG_KUSPIT_ORIGIN_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_ORIGIN_STATE_MANAGER'),
};
